module.exports = __webpack_public_path__ + "assets/img/1016.c6abf2fc.png";